const Contract = () =>
  import(
    /* webpackChunkName: "courier-contract" */ '@/pages/courier/contract/index.vue'
  )
const CreateContract = () =>
  import(
    /* webpackChunkName: "courier-contract" */ '@/pages/courier/contract/create.vue'
  )
const EditContract = () =>
  import(
    /* webpackChunkName: "courier-contract" */ '@/pages/courier/contract/edit.vue'
  )

export default {
  path: 'contract',
  meta: {
    label: 'contract',
    auth: 'contract'
  },
  component: {
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'CourierContractReport',
      path: '',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: Contract
    },
    {
      name: 'CourierCreateContract',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: CreateContract
    },
    {
      name: 'CourierEditContract',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: EditContract,
      props: true
    }
  ]
}
